import React, { useState, useEffect } from 'react';
import { IDoctor, ITreatment } from '../types/clinic.types';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloseIcon from '@mui/icons-material/Close';
interface Props {
  doctor: IDoctor | null; // null for 'Add', object for 'Edit'
  allTreatments: ITreatment[];
  onClose: () => void;
  onSave: (doctor: IDoctor) => void;
}

const DEFAULT_DOCTOR: Omit<IDoctor, 'id'> = {
  fullName: '',
  studies: [],
  speciality: '',
  languages: [],
  assignedTreatmentIds: [],
  image: 'https://via.placeholder.com/150.png?text=New+Doctor',
};

export const DoctorFormModal: React.FC<Props> = ({ doctor, allTreatments, onClose, onSave }) => {
  const [formData, setFormData] = useState(doctor || DEFAULT_DOCTOR);
  const isEditMode = !!doctor;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === 'languages' ? value.split(',').map(s => s.trim()) : value,
    }));
  };

  const handleTreatmentToggle = (treatmentId: string) => {
    const currentIds = formData.assignedTreatmentIds;
    const newIds = currentIds.includes(treatmentId)
      ? currentIds.filter((id) => id !== treatmentId)
      : [...currentIds, treatmentId];
    
    setFormData(prev => ({ ...prev, assignedTreatmentIds: newIds }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData as IDoctor);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-dialog" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit}>
          <div className="modal-header">
            <h3>{isEditMode ? 'Edit Doctor' : 'Add New Doctor'}</h3>
            <button type="button" className="btn btn-icon modal-close-btn" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal-body">
          
            
            <div className="form-group">
              <label>Assign Treatments</label>
              <div className="treatment-checkbox-list" style={{ maxHeight: '150px', overflowY: 'auto', border: '1px solid #dee2e6', padding: '0.5rem', borderRadius: '8px' }}>
                {allTreatments.length === 0 && <p>No treatments available to assign.</p>}
                {allTreatments.map(t => (
                  <div className="form-check" key={t.id}>
                    <input 
                      type="checkbox" 
                      id={`t-${t.id}`}
                      checked={formData.assignedTreatmentIds.includes(t.id)}
                      onChange={() => handleTreatmentToggle(t.id)}
                    />
                    <label htmlFor={`t-${t.id}`}>{t.name}</label>
                  </div>
                ))}
              </div>
            </div>
            
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
             Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};